import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'magenty-info-message',
    imports: [CommonModule, SharedModule, ToastModule],
    templateUrl: './info-message.component.html',
    styleUrl: './info-message.component.scss'
})
export class InfoMessageComponent {}
